import { useEffect } from "react";
import { AuthActions, AuthState } from "../../../core/auth/auth.slice";
import { useAppDispatch } from "../../../utils/store";
import { Navigate } from "react-router-dom";
import {
  AppPage,
  AppPageUrls,
} from "../../../core/navigation/navigation.slice";

const Login = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(AuthActions.setAuthState(AuthState.PhoneEntrance));
  }, []);

  return <Navigate to={AppPageUrls[AppPage.OrdersList]} />;
};

export default Login;
